module.exports = __webpack_public_path__ + "img/10C.19635027.png";